var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OverviewDeviceCardKpi,{attrs:{"label":_vm.label}},[(_setup.isMetricNil)?[_vm._v(" - ")]:[_vm._t("default",null,{"value":_setup.nonNullAssertedMetricValue})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }